import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LogPublisher, LogConsole, LogLocalStorage, LogWebApi } from "./log-publishers";

// ****************************************************
// Logging Publishers Service Class
// ****************************************************
@Injectable()
export class LogPublishersService {
  constructor(
  ){
    // Build publishers arrays
    this.buildPublishers();
  }

  // Public properties
  publishers: LogPublisher[] = [];

  // *************************
  // Public methods
  // *************************
  // Build publishers array
  buildPublishers(): void {
    // Add Console Logging to Publisher array
    this.publishers.push(new LogConsole());
    // Create instance of `LogLocalStorage` Class
    this.publishers.push(new LogLocalStorage());
  }
}